export const baseAPIUrl = process.env.REACT_APP_BASE_API_ERP;

export const baseConfig = {
	baseUrl: baseAPIUrl,
	prepareHeaders: (headers: any) => {
		headers.set('Authorization', `Bearer ${localStorage.getItem('token') || ''}`);
		return headers;
	},
};
